import React from "react";
import { useParams, Outlet } from "react-router-dom";
import ExportList from "../export-list";
import ExportDetail from "../export-detail";

const ExportContainer = () => {

    let { exportId } = useParams();

    return (
        <>
            <div className="left">
                <ExportList />
            </div>
            <div className="right">
                {exportId && false &&
                    <ExportDetail key={exportId} exportId />
                }
            </div>
        </>
    )

}

export default ExportContainer